import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Reveal from '../../components/Reveal';

/**
 * DoorlyMarket — Sample Loan Tape (public).
 *
 * Linked from the "View Sample Tape" CTA on /market. Renders an
 * institutional-style loan tape viewer with portfolio summary cards
 * and a 25-loan illustrative dataset. Brand styling matches
 * MarketLanding exactly (#3a6ad9 / #fffd5b accents, white cards,
 * blue footer).
 */

const POOL_SUMMARY = [
  { label: 'Pool Size',         value: '25 Loans' },
  { label: 'Total UPB',         value: '$14,473,000' },
  { label: 'Avg FICO',          value: '650' },
  { label: 'Avg LTV',           value: '84.6%' },
  { label: 'WA Coupon',         value: '9.574%' },
  { label: 'Delinquency',       value: '0.00%' },
  { label: 'Geographic Mix',    value: 'TX 48% / FL 52%' },
  { label: 'Doc Type Mix',      value: 'Full Doc 52% / Alt Doc 48%' },
];

const LOAN_TAPE = [
  { loan_id: 83022, address: '8409 Hempstead Rd Unit H, Houston, TX 77008', property_type: 'SFR', note_date: '02/12/2026', status: 'Current', amort_type: 'Fixed', purchase_price: '$420,000', down_pct: '10%', loan_amount: '$378,000', principal_balance: '$378,000', ltv: '90.0%', fico: 650, doc_type: 'Full Doc', dti: '42%', rate: '9.625%', term: '360 Mo.', pi: '$3,212.96', first_payment: '04/01/2026', lates: '0x30x12', maturity: '03/01/2056', owner_occupied: 'Yes' },
  { loan_id: 83025, address: '4335 Camden Ave, Dallas, TX 75206', property_type: 'SFR', note_date: '02/12/2026', status: 'Current', amort_type: 'Fixed', purchase_price: '$510,000', down_pct: '15%', loan_amount: '$433,500', principal_balance: '$433,500', ltv: '85.0%', fico: 695, doc_type: 'Alt Doc', dti: '44%', rate: '9.625%', term: '360 Mo.', pi: '$3,684.70', first_payment: '04/01/2026', lates: '0x30x12', maturity: '03/01/2056', owner_occupied: 'Yes' },
  { loan_id: 83026, address: '1911 Ohlen Rd, Austin, TX 78757', property_type: 'SFR', note_date: '02/12/2026', status: 'Current', amort_type: 'Fixed', purchase_price: '$760,000', down_pct: '10%', loan_amount: '$684,000', principal_balance: '$684,000', ltv: '90.0%', fico: 642, doc_type: 'Full Doc', dti: '41%', rate: '9.625%', term: '360 Mo.', pi: '$5,813.93', first_payment: '04/01/2026', lates: '0x30x12', maturity: '03/01/2056', owner_occupied: 'Yes' },
  { loan_id: 83031, address: '106 Irvington, San Antonio, TX 78209', property_type: 'SFR', note_date: '02/13/2026', status: 'Current', amort_type: 'Fixed', purchase_price: '$355,000', down_pct: '10%', loan_amount: '$319,500', principal_balance: '$319,500', ltv: '90.0%', fico: 708, doc_type: 'Alt Doc', dti: '45%', rate: '9.750%', term: '360 Mo.', pi: '$2,745.00', first_payment: '04/01/2026', lates: '0x30x12', maturity: '03/01/2056', owner_occupied: 'Yes' },
  { loan_id: 83035, address: '308 N Bailey Ave, Fort Worth, TX 76107', property_type: 'SFR', note_date: '02/13/2026', status: 'Current', amort_type: 'Fixed', purchase_price: '$620,000', down_pct: '10%', loan_amount: '$558,000', principal_balance: '$558,000', ltv: '90.0%', fico: 620, doc_type: 'Full Doc', dti: '40%', rate: '9.625%', term: '360 Mo.', pi: '$4,742.94', first_payment: '04/01/2026', lates: '0x30x12', maturity: '03/01/2056', owner_occupied: 'Yes' },
  { loan_id: 83039, address: '6613 Crown Forest Dr, Plano, TX 75024', property_type: 'SFR', note_date: '02/16/2026', status: 'Current', amort_type: 'Fixed', purchase_price: '$895,000', down_pct: '15%', loan_amount: '$760,750', principal_balance: '$760,750', ltv: '85.0%', fico: 608, doc_type: 'Full Doc', dti: '39%', rate: '9.625%', term: '360 Mo.', pi: '$6,466.29', first_payment: '04/01/2026', lates: '0x30x12', maturity: '03/01/2056', owner_occupied: 'Yes' },
  { loan_id: 83044, address: '2677 Wiregrass Rd, Frisco, TX 75033', property_type: 'SFR', note_date: '02/17/2026', status: 'Current', amort_type: 'Fixed', purchase_price: '$1,150,000', down_pct: '15%', loan_amount: '$977,500', principal_balance: '$977,500', ltv: '85.0%', fico: 648, doc_type: 'Alt Doc', dti: '43%', rate: '9.500%', term: '360 Mo.', pi: '$8,219.35', first_payment: '04/01/2026', lates: '0x30x12', maturity: '03/01/2056', owner_occupied: 'Yes' },
  { loan_id: 83045, address: '1714 Forestlake Dr, Sugar Land, TX 77479', property_type: 'SFR', note_date: '02/17/2026', status: 'Current', amort_type: 'Fixed', purchase_price: '$540,000', down_pct: '10%', loan_amount: '$486,000', principal_balance: '$486,000', ltv: '90.0%', fico: 662, doc_type: 'Full Doc', dti: '44%', rate: '9.750%', term: '360 Mo.', pi: '$4,175.49', first_payment: '04/01/2026', lates: '0x30x12', maturity: '03/01/2056', owner_occupied: 'Yes' },
  { loan_id: 83048, address: '26714 Abbey Springs Ln, Katy, TX 77494', property_type: 'SFR', note_date: '02/17/2026', status: 'Current', amort_type: 'Fixed', purchase_price: '$470,000', down_pct: '15%', loan_amount: '$399,500', principal_balance: '$399,500', ltv: '85.0%', fico: 653, doc_type: 'Alt Doc', dti: '45%', rate: '9.650%', term: '360 Mo.', pi: '$3,403.02', first_payment: '04/01/2026', lates: '0x30x12', maturity: '03/01/2056', owner_occupied: 'Yes' },
  { loan_id: 83052, address: '1813 Creek Ledge Pl, Round Rock, TX 78664', property_type: 'SFR', note_date: '02/17/2026', status: 'Current', amort_type: 'Fixed', purchase_price: '$520,000', down_pct: '20%', loan_amount: '$416,000', principal_balance: '$416,000', ltv: '80.0%', fico: 592, doc_type: 'Full Doc', dti: '40%', rate: '9.500%', term: '360 Mo.', pi: '$3,497.95', first_payment: '04/01/2026', lates: '0x30x12', maturity: '03/01/2056', owner_occupied: 'Yes' },
  { loan_id: 83053, address: '3909 Cherrybark St, McKinney, TX 75071', property_type: 'SFR', note_date: '02/19/2026', status: 'Current', amort_type: 'Fixed', purchase_price: '$680,000', down_pct: '10%', loan_amount: '$612,000', principal_balance: '$612,000', ltv: '90.0%', fico: 725, doc_type: 'Alt Doc', dti: '43%', rate: '9.750%', term: '360 Mo.', pi: '$5,258.03', first_payment: '04/01/2026', lates: '0x30x12', maturity: '03/01/2056', owner_occupied: 'Yes' },
  { loan_id: 83057, address: '2403 Bluffview Ct, Arlington, TX 76011', property_type: 'SFR', note_date: '02/19/2026', status: 'Current', amort_type: 'Fixed', purchase_price: '$410,000', down_pct: '15%', loan_amount: '$348,500', principal_balance: '$348,500', ltv: '85.0%', fico: 580, doc_type: 'Alt Doc', dti: '49%', rate: '9.750%', term: '360 Mo.', pi: '$2,994.15', first_payment: '04/01/2026', lates: '0x30x12', maturity: '03/01/2056', owner_occupied: 'Yes' },
  { loan_id: 85011, address: '1895 SW 25th St, Miami, FL 33133', property_type: 'SFR', note_date: '02/17/2026', status: 'Current', amort_type: 'Fixed', purchase_price: '$990,000', down_pct: '20%', loan_amount: '$792,000', principal_balance: '$792,000', ltv: '80.0%', fico: 610, doc_type: 'Full Doc', dti: '41%', rate: '9.500%', term: '360 Mo.', pi: '$6,659.57', first_payment: '04/01/2026', lates: '0x30x12', maturity: '03/01/2056', owner_occupied: 'Yes' },
  { loan_id: 85017, address: '1905 S West Shore Blvd, Tampa, FL 33629', property_type: 'SFR', note_date: '02/17/2026', status: 'Current', amort_type: 'Fixed', purchase_price: '$560,000', down_pct: '10%', loan_amount: '$504,000', principal_balance: '$504,000', ltv: '90.0%', fico: 700, doc_type: 'Alt Doc', dti: '42%', rate: '9.625%', term: '360 Mo.', pi: '$4,283.95', first_payment: '04/01/2026', lates: '0x30x12', maturity: '03/01/2056', owner_occupied: 'Yes' },
  { loan_id: 85019, address: '8762 Fort Shea Ave, Orlando, FL 32822', property_type: 'SFR', note_date: '02/20/2026', status: 'Current', amort_type: 'Fixed', purchase_price: '$480,000', down_pct: '10%', loan_amount: '$432,000', principal_balance: '$432,000', ltv: '90.0%', fico: 635, doc_type: 'Full Doc', dti: '44%', rate: '9.750%', term: '360 Mo.', pi: '$3,711.55', first_payment: '04/01/2026', lates: '0x30x12', maturity: '03/01/2056', owner_occupied: 'Yes' },
  { loan_id: 85026, address: '13031 Bentwater Dr, Jacksonville, FL 32246', property_type: 'SFR', note_date: '02/20/2026', status: 'Current', amort_type: 'Fixed', purchase_price: '$395,000', down_pct: '25%', loan_amount: '$296,250', principal_balance: '$296,250', ltv: '75.0%', fico: 550, doc_type: 'Full Doc', dti: '50%', rate: '9.500%', term: '360 Mo.', pi: '$2,491.03', first_payment: '04/01/2026', lates: '0x30x12', maturity: '03/01/2056', owner_occupied: 'Yes' },
  { loan_id: 85029, address: '1309 NE 3rd St, Fort Lauderdale, FL 33301', property_type: 'SFR', note_date: '02/20/2026', status: 'Current', amort_type: 'Fixed', purchase_price: '$1,240,000', down_pct: '20%', loan_amount: '$992,000', principal_balance: '$992,000', ltv: '80.0%', fico: 690, doc_type: 'Alt Doc', dti: '40%', rate: '9.500%', term: '360 Mo.', pi: '$8,341.27', first_payment: '04/01/2026', lates: '0x30x12', maturity: '03/01/2056', owner_occupied: 'Yes' },
  { loan_id: 85038, address: '4484 Bocaire Blvd, Boca Raton, FL 33487', property_type: 'SFR', note_date: '02/24/2026', status: 'Current', amort_type: 'Fixed', purchase_price: '$1,450,000', down_pct: '30%', loan_amount: '$1,015,000', principal_balance: '$1,015,000', ltv: '70.0%', fico: 588, doc_type: 'Full Doc', dti: '42%', rate: '9.375%', term: '360 Mo.', pi: '$8,442.26', first_payment: '04/01/2026', lates: '0x30x12', maturity: '03/01/2056', owner_occupied: 'Yes' },
  { loan_id: 85040, address: '1219 Avondale Ln, West Palm Beach, FL 33409', property_type: 'SFR', note_date: '02/24/2026', status: 'Current', amort_type: 'Fixed', purchase_price: '$780,000', down_pct: '15%', loan_amount: '$663,000', principal_balance: '$663,000', ltv: '85.0%', fico: 667, doc_type: 'Alt Doc', dti: '44%', rate: '9.500%', term: '360 Mo.', pi: '$5,574.86', first_payment: '04/01/2026', lates: '0x30x12', maturity: '03/01/2056', owner_occupied: 'Yes' },
  { loan_id: 85045, address: '1038 Crescent Lake Dr N, Saint Petersburg, FL 33701', property_type: 'SFR', note_date: '02/24/2026', status: 'Current', amort_type: 'Fixed', purchase_price: '$520,000', down_pct: '10%', loan_amount: '$468,000', principal_balance: '$468,000', ltv: '90.0%', fico: 632, doc_type: 'Full Doc', dti: '41%', rate: '9.625%', term: '360 Mo.', pi: '$3,977.95', first_payment: '04/01/2026', lates: '0x30x12', maturity: '03/01/2056', owner_occupied: 'Yes' },
  { loan_id: 85046, address: '1155 Tahiti Pkwy, Sarasota, FL 34236', property_type: 'SFR', note_date: '02/25/2026', status: 'Current', amort_type: 'Fixed', purchase_price: '$675,000', down_pct: '20%', loan_amount: '$540,000', principal_balance: '$540,000', ltv: '80.0%', fico: 660, doc_type: 'Full Doc', dti: '40%', rate: '9.500%', term: '360 Mo.', pi: '$4,540.61', first_payment: '04/01/2026', lates: '0x30x12', maturity: '03/01/2056', owner_occupied: 'Yes' },
  { loan_id: 85049, address: '1410 Curlew Ave, Naples, FL 34102', property_type: 'SFR', note_date: '02/27/2026', status: 'Current', amort_type: 'Fixed', purchase_price: '$1,550,000', down_pct: '20%', loan_amount: '$1,240,000', principal_balance: '$1,240,000', ltv: '80.0%', fico: 732, doc_type: 'Alt Doc', dti: '39%', rate: '9.500%', term: '360 Mo.', pi: '$10,426.59', first_payment: '04/01/2026', lates: '0x30x12', maturity: '03/01/2056', owner_occupied: 'Yes' },
  { loan_id: 85052, address: '9626 NW 27th St, Coral Springs, FL 33065', property_type: 'SFR', note_date: '02/27/2026', status: 'Current', amort_type: 'Fixed', purchase_price: '$495,000', down_pct: '10%', loan_amount: '$445,500', principal_balance: '$445,500', ltv: '90.0%', fico: 692, doc_type: 'Alt Doc', dti: '46%', rate: '9.750%', term: '360 Mo.', pi: '$3,827.53', first_payment: '04/01/2026', lates: '0x30x12', maturity: '03/01/2056', owner_occupied: 'Yes' },
  { loan_id: 85057, address: '6611 McKinley St, Hollywood, FL 33024', property_type: 'SFR', note_date: '02/27/2026', status: 'Current', amort_type: 'Fixed', purchase_price: '$460,000', down_pct: '20%', loan_amount: '$368,000', principal_balance: '$368,000', ltv: '80.0%', fico: 703, doc_type: 'Full Doc', dti: '42%', rate: '9.500%', term: '360 Mo.', pi: '$3,094.34', first_payment: '04/01/2026', lates: '0x30x12', maturity: '03/01/2056', owner_occupied: 'Yes' },
  { loan_id: 85061, address: '2776 Tropical Lake Dr, Kissimmee, FL 34741', property_type: 'SFR', note_date: '02/27/2026', status: 'Current', amort_type: 'Fixed', purchase_price: '$430,000', down_pct: '20%', loan_amount: '$344,000', principal_balance: '$344,000', ltv: '80.0%', fico: 600, doc_type: 'Alt Doc', dti: '49%', rate: '9.500%', term: '360 Mo.', pi: '$2,892.54', first_payment: '04/01/2026', lates: '0x30x12', maturity: '03/01/2056', owner_occupied: 'Yes' },
];

const COLUMNS = [
  { label: 'Loan ID',          field: 'loan_id',           sticky: true,  align: 'left'  },
  { label: 'Property Address', field: 'address',                          align: 'left'  },
  { label: 'Prop Type',        field: 'property_type',                    align: 'left'  },
  { label: 'Note Date',        field: 'note_date',                        align: 'left'  },
  { label: 'Status',           field: 'status',            kind: 'status' },
  { label: 'Amort',            field: 'amort_type',                       align: 'left'  },
  { label: 'Purchase Price',   field: 'purchase_price',                   align: 'right' },
  { label: 'Down %',           field: 'down_pct',                         align: 'right' },
  { label: 'Loan Amount',      field: 'loan_amount',                      align: 'right' },
  { label: 'Prin. Balance',    field: 'principal_balance',                align: 'right' },
  { label: 'LTV',              field: 'ltv',                              align: 'right' },
  { label: 'FICO',             field: 'fico',                             align: 'right' },
  { label: 'Doc Type',         field: 'doc_type',          kind: 'doc'    },
  { label: 'DTI',              field: 'dti',                              align: 'right' },
  { label: 'Rate',             field: 'rate',                             align: 'right' },
  { label: 'Term',             field: 'term',                             align: 'right' },
  { label: 'P&I Payment',      field: 'pi',                               align: 'right' },
  { label: 'First Payment',    field: 'first_payment',                    align: 'left'  },
  { label: 'MTG Lates',        field: 'lates',                            align: 'left'  },
  { label: 'Maturity',         field: 'maturity',                         align: 'left'  },
  { label: 'OO',               field: 'owner_occupied',    align: 'center' },
];

export default function SampleTape() {
  const navigate = useNavigate();
  useEffect(() => { document.title = 'Doorly | Sample Loan Tape'; }, []);

  const REGISTER_PATH = '/market/register';

  const cellBase = {
    padding: '10px 14px',
    fontSize: '13px',
    color: '#111827',
    borderBottom: '1px solid #e5e7eb',
    whiteSpace: 'nowrap',
  };
  const headerCell = {
    padding: '10px 14px',
    fontSize: '12px',
    fontWeight: 700,
    color: '#ffffff',
    backgroundColor: '#111111',
    textTransform: 'uppercase',
    letterSpacing: '0.04em',
    textAlign: 'left',
    whiteSpace: 'nowrap',
    borderBottom: '1px solid #111111',
    position: 'sticky',
    top: 0,
    zIndex: 2,
  };

  return (
    <div className="min-h-screen flex flex-col bg-white">

      {/* ── NAV ── */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-gray-100 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between" style={{ height: '4.5rem' }}>
            <Link to="/market" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center' }}>
              <img
                src="/doorly-market-logo.png"
                alt="Doorly Market"
                style={{ height: '40px', width: 'auto', display: 'block' }}
              />
            </Link>
            <Link to="/market" className="text-sm font-semibold text-black hover:text-doorly-blue transition-colors duration-200" style={{ textDecoration: 'none' }}>
              ← Back to DoorlyMarket
            </Link>
          </div>
        </div>
      </nav>

      {/* ── PAGE TITLE ── */}
      <section className="pt-28 sm:pt-36 pb-12 px-4 sm:px-6 lg:px-8" style={{ background: '#3a6ad9' }}>
        <div className="max-w-7xl mx-auto">
          <Reveal>
            <div className="inline-flex items-center gap-2 text-xs font-semibold px-3 py-1.5 rounded-full mb-5 uppercase tracking-wider"
              style={{
                backgroundColor: 'rgba(255,255,255,0.12)',
                border: '1px solid rgba(255,255,255,0.25)',
                color: '#ffffff',
              }}>
              <span className="w-2 h-2 rounded-full animate-pulse" style={{ backgroundColor: '#ffffff' }} />
              Sample Tape
            </div>
          </Reveal>
          <Reveal delay={80}>
            <h1 className="text-2xl sm:text-3xl md:text-4xl font-extrabold leading-tight tracking-tight mb-3 text-white">
              Doorly <span style={{ color: '#fffd5b' }}>AFM<sup style={{ fontSize: '0.5em', verticalAlign: 'super' }}>™</sup></span> — Sample Loan Tape
            </h1>
          </Reveal>
          <Reveal delay={140}>
            <div className="text-sm sm:text-base font-semibold mb-4" style={{ color: 'rgba(255,255,255,0.85)' }}>
              Pool Date: February 2026 &nbsp;|&nbsp; 25 Loans &nbsp;|&nbsp; All Current
            </div>
          </Reveal>
          <Reveal delay={200}>
            <p className="text-sm sm:text-base leading-relaxed max-w-4xl" style={{ color: 'rgba(255,255,255,0.7)' }}>
              This tape represents a sample of Doorly-originated Ability-First Mortgage<sup style={{ fontSize: '0.65em', verticalAlign: 'super' }}>™</sup> loans. Loan IDs, addresses, and borrower data are illustrative. All loans are owner-occupied, first-lien, 30-year fixed-rate residential mortgages originated in Texas and Florida.
            </p>
          </Reveal>
        </div>
      </section>

      {/* ── PORTFOLIO SUMMARY CARDS ── */}
      <section className="py-12 px-4 sm:px-6 lg:px-8 border-t border-gray-100" style={{ backgroundColor: '#f9fafb' }}>
        <div className="max-w-7xl mx-auto">
          <Reveal>
            <div className="inline-block text-xs font-bold uppercase mb-5"
              style={{ color: '#3a6ad9', letterSpacing: '0.1em', padding: '4px 14px', background: '#edf1fb', borderRadius: '20px', border: '1px solid #c5d3f5' }}>
              Portfolio Summary
            </div>
          </Reveal>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4">
            {POOL_SUMMARY.map((m, i) => {
              const isAccent = i % 2 === 0;
              return (
                <Reveal key={m.label} delay={i * 50} y={10}>
                  <div className="rounded-lg p-4 sm:p-5 h-full" style={{
                    background: isAccent ? '#eff4ff' : '#ffffff',
                    border: `1px solid ${isAccent ? '#bfcff8' : '#e5e7eb'}`,
                  }}>
                    <div style={{ fontSize: '11px', fontWeight: 700, color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '8px' }}>
                      {m.label}
                    </div>
                    <div style={{
                      fontSize: m.value.length > 18 ? '14px' : '20px',
                      fontWeight: 800,
                      color: isAccent ? '#3a6ad9' : '#111111',
                      lineHeight: 1.2,
                    }}>
                      {m.value}
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </section>

      {/* ── LOAN TAPE TABLE ── */}
      <section className="py-12 px-4 sm:px-6 lg:px-8 bg-white border-t border-gray-100">
        <div className="max-w-7xl mx-auto">
          <Reveal>
            <div className="inline-block text-xs font-bold uppercase mb-4"
              style={{ color: '#3a6ad9', letterSpacing: '0.1em', padding: '4px 14px', background: '#edf1fb', borderRadius: '20px', border: '1px solid #c5d3f5' }}>
              Loan-Level Detail
            </div>
            <h2 className="text-2xl sm:text-3xl font-bold text-black mb-2 leading-tight" style={{ letterSpacing: '-0.5px' }}>
              25-Loan Sample Tape
            </h2>
            <p className="text-gray-600 text-sm sm:text-base mb-6">
              Scroll horizontally to view all columns. Loan ID stays pinned to the left.
            </p>
          </Reveal>

          <div style={{
            border: '1px solid #e5e7eb',
            borderRadius: '8px',
            overflow: 'hidden',
            boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
          }}>
            <div className="scroll-x" style={{ maxHeight: '70vh', overflowY: 'auto', WebkitOverflowScrolling: 'touch' }}>
              <table style={{ width: '100%', minWidth: 1400, borderCollapse: 'collapse', fontVariantNumeric: 'tabular-nums' }}>
                <thead>
                  <tr>
                    {COLUMNS.map(col => (
                      <th key={col.field}
                        style={{
                          ...headerCell,
                          textAlign: col.align || 'left',
                          ...(col.sticky ? { left: 0, zIndex: 3, backgroundColor: '#111111' } : {}),
                        }}>
                        {col.label}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {LOAN_TAPE.map((loan, rowIdx) => {
                    const rowBg = rowIdx % 2 === 0 ? '#ffffff' : '#f9fafb';
                    return (
                      <tr key={loan.loan_id}>
                        {COLUMNS.map(col => {
                          const v = loan[col.field];
                          const cellStyle = {
                            ...cellBase,
                            textAlign: col.align || 'left',
                            backgroundColor: rowBg,
                            ...(col.sticky ? { position: 'sticky', left: 0, zIndex: 1, fontWeight: 700, color: '#111827' } : {}),
                          };

                          if (col.kind === 'status') {
                            return (
                              <td key={col.field} style={cellStyle}>
                                <span style={{
                                  display: 'inline-block',
                                  fontSize: '11px',
                                  fontWeight: 700,
                                  padding: '3px 10px',
                                  borderRadius: '9999px',
                                  background: '#f0fde4',
                                  color: '#111111',
                                  border: '1px solid #d4f9a0',
                                }}>
                                  {v}
                                </span>
                              </td>
                            );
                          }
                          if (col.kind === 'doc') {
                            const isFull = v === 'Full Doc';
                            return (
                              <td key={col.field} style={cellStyle}>
                                <span style={{
                                  display: 'inline-block',
                                  fontSize: '11px',
                                  fontWeight: 700,
                                  padding: '3px 10px',
                                  borderRadius: '9999px',
                                  background: isFull ? '#eff4ff' : '#f3f4f6',
                                  color: isFull ? '#3a6ad9' : '#374151',
                                  border: `1px solid ${isFull ? '#bfcff8' : '#e5e7eb'}`,
                                }}>
                                  {v}
                                </span>
                              </td>
                            );
                          }
                          return <td key={col.field} style={cellStyle}>{v}</td>;
                        })}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div className="scroll-hint" style={{ padding: '6px 12px' }}>← Scroll horizontally to see all columns →</div>
          </div>
        </div>
      </section>

      {/* ── FOOTER ── */}
      <footer className="px-5 sm:px-10 py-6 sm:py-7 mt-auto" style={{
        background: '#3a6ad9',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        borderTop: '1px solid rgba(255,255,255,0.08)',
      }}>
        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4">
          <div style={{ fontSize: '12px', color: 'rgba(255,255,255,0.35)' }}>
            Go Doorly, LLC | NMLS #2764749 | Equal Housing Opportunity
          </div>
          <div className="flex flex-wrap gap-x-5 gap-y-2 sm:gap-x-6">
            {[
              { label: 'Sign In',                  path: '/market/login' },
              { label: 'Request Access',           path: REGISTER_PATH },
              { label: 'Investor Dashboard',       path: '/market/dashboard' },
              { label: 'Support',                  path: 'mailto:investors@godoorly.com' },
            ].map(link => (
              <span
                key={link.label}
                onClick={() => link.path.startsWith('mailto') ? (window.location.href = link.path) : navigate(link.path)}
                style={{ fontSize: '12px', color: 'rgba(255,255,255,0.5)', cursor: 'pointer', transition: 'color 0.15s' }}
                onMouseEnter={e => e.target.style.color = '#fffd5b'}
                onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.5)'}
              >
                {link.label}
              </span>
            ))}
          </div>
        </div>

        <div style={{
          fontSize: '11px',
          color: 'rgba(255,255,255,0.35)',
          lineHeight: 1.6,
          borderTop: '1px solid rgba(255,255,255,0.08)',
          paddingTop: '14px',
          marginTop: '4px',
        }}>
          DoorlyMarket is intended solely for institutional and accredited counterparties. Access to loan-level information and offerings is subject to approval and confidentiality requirements. Loan IDs and addresses shown are illustrative sample data only.
        </div>
      </footer>
    </div>
  );
}
